import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";

export function SurveySubmissionNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Survey submission unavailable</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            The submission you&apos;re looking for doesn't exist, or the link may be broken. Check your survey list for
            available surveys, or try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}
